export default "__VITE_ASSET__Dve6MGMf__"